import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  generatedTestCases: [],
  approvedTestCases: [],
  discardedTestCases: [],
};

const testCasesSlice = createSlice({
  name: 'testCases',
  initialState,
  reducers: {
    addGeneratedTestCase: (state, action) => {
      state.generatedTestCases.push({
        id: action.payload.id,
        title: action.payload.title,
        description: action.payload.description,
        type: action.payload.type,
        testdata: action.payload.testdata
      });
    },
    approveTestCase: (state, action) => {
      state.approvedTestCases.push(action.payload);
      state.generatedTestCases = state.generatedTestCases.filter(
        (testCase) => testCase.id !== action.payload.id
      );
    },
    discardTestCase: (state, action) => {
      state.discardedTestCases.push(action.payload);
      state.generatedTestCases = state.generatedTestCases.filter(
        (testCase) => testCase.id !== action.payload.id
      );
    },
    discardApprovedTestCase: (state, action) => {
      state.discardedTestCases.push(action.payload);
      state.approvedTestCases = state.approvedTestCases.filter(
        (testCase) => testCase.id !== action.payload.id
      );
    },
    reviewTestCase: (state, action) => {
      state.generatedTestCases.push(action.payload);
      state.approvedTestCases = state.approvedTestCases.filter(
        (testCase) => testCase.id !== action.payload.id
      );
    },
    clearGeneratedTestCase: (state, action) => {
      state.generatedTestCases = [];
      state.approvedTestCases = [];
    },
    removeSpecificApprovedTestOnSave: (state, action) => {
      state.approvedTestCases = state.approvedTestCases.filter(
        testCase => testCase.id !== action.payload.id
      );
    },
  },
});

export const {
  addGeneratedTestCase,
  approveTestCase,
  discardTestCase,
  discardApprovedTestCase,
  reviewTestCase,
  clearGeneratedTestCase,
  removeSpecificApprovedTestOnSave,
} = testCasesSlice.actions;

export default testCasesSlice.reducer;